
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22.8 20l13.1 13.1-2.8 2.8L20 22.8 6.9 35.9l-2.8-2.8L17.2 20 4.1 6.9l2.8-2.8L20 17.2 33.1 4.1l2.8 2.8L22.8 20z","fill":"#434c56"}})])
          )
        }
      }
    